<template>
  <div class="paymentPage">
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseData.reason"
        rows="1"
        autosize
        label="付款事由："
        type="textarea"
        placeholder="请输入...  "
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.collectingCompany"
        placeholder="请输入...  "
        readonly
        class="ggInput"
        label="收款单位："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.paymentTypeName"
        placeholder="请选择"
        readonly
        class="ggInput"
        label="支付方式："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="baseData.paymentType == 'zz'">
      <van-field
        v-model="baseData.depositBank"
        placeholder="请输入...  "
        readonly
        class="ggInput"
        label="开户行："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="baseData.paymentType == 'zz'">
      <van-field
        v-model="baseData.bankAccount"
        placeholder="请输入...  "
        readonly
        class="ggInput"
        label="银行账户："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        type="number"
        v-model="baseData.amount"
        placeholder="请输入...  "
        readonly
        class="ggInput"
        label="支付金额："
      />
    </van-cell-group>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseData.remarks"
        rows="1"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入...  "
        readonly
      />
    </van-cell-group>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage ,is_wei} from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
export default {
  name: "payment-detail",
  props: {
    id: {
      //借款记录id
      type: String,
      default: ""
    }
  },
  components: {
    refreshPage
  },
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseData: {
        amount: "", //申请原因
        bankAccount: "", //申请名称
        baseAnnexes: [],
        collectingCompany: "", //s收款单位
        depositBank: "", //开户银行
        paymentTypeName: "", //付款方式name
        paymentType: "", //付款方式code
        reason: "", //付款事由
        remarks: "", //备注
        verifyStatus: "hold"
      },
      refreshPage: false // 网络请求失败时显示
    };
  },
  mounted() {
    this.commonId = this.id; //申请Id
     if(is_wei()){
      document.title="付款申请";
    }
    this.$nextTick(() => {
      this.initPage();
    });
  },
  methods: {
    initPage() {
      let _this = this;
      // 接口详情
      _this.$api.finance.payment
        .details(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            _this.baseData.paymentTypeName =
              // _this.baseData.paymentType == "zz" ? "转账" : "现金";
              _this.baseData.paymentType == "zz" ? "转账" : _this.baseData.paymentType == "xj"?"现金":
              _this.baseData.paymentType == "hp"
                ? "汇票":"保函";
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.paymentPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
  .editBtnbox.btnBox {
    .btn {
      width: 100%;
    }
    .btn:first-child {
      // background-color: #f34646;
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
}
</style>
